// Stacked serif wordmark logo for Unite Recruitment, matching the Canva brand.
// Renders pure HTML so it inherits color from parent.

export default function Logo({ className = "", size = "md", inline = false }) {
  const sizes = {
    sm: { unite: "text-2xl", recruit: "text-[10px]", gap: "mt-0.5" },
    md: { unite: "text-3xl", recruit: "text-[11px]", gap: "mt-1" },
    lg: { unite: "text-5xl md:text-6xl", recruit: "text-sm", gap: "mt-2" },
    xl: { unite: "text-7xl md:text-8xl lg:text-9xl", recruit: "text-base md:text-lg", gap: "mt-3" },
  };
  const s = sizes[size] || sizes.md;

  if (inline) {
    return (
      <span className={`font-headings leading-none ${className}`}>
        Unite Recruitment
      </span>
    );
  }

  return (
    <span className={`inline-flex flex-col leading-[0.9] ${className}`}>
      <span className={`font-headings ${s.unite} tracking-tight`}>Unite</span>
      <span className={`font-headings ${s.recruit} ${s.gap} uppercase tracking-[0.35em] font-body font-medium opacity-70`}>
        Recruitment
      </span>
    </span>
  );
}
